export default "__VITE_ASSET__5dfe42d1__"